module.exports = __webpack_public_path__ + "static/media/Roberta_Matinal.d85d3622.png";